"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const CollectionCalendar_1 = __importDefault(require("./CollectionCalendar"));
const CollectionDescription_1 = __importDefault(require("./CollectionDescription"));
const CollectionHeading_1 = __importDefault(require("./CollectionHeading"));
const CollectionImage_1 = __importDefault(require("./CollectionImage"));
const CollectionItem_1 = __importDefault(require("./CollectionItem"));
const CollectionMeta_1 = __importDefault(require("./CollectionMeta"));
const CollectionMetaItem_1 = __importDefault(require("./CollectionMetaItem"));
const CollectionComponent = (0, react_1.forwardRef)(({ children, className, condensed, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("ul", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-collection', condensed && 'usa-collection--condensed', className), ...props, children: children }));
});
const Collection = Object.assign(CollectionComponent, {
    Calendar: CollectionCalendar_1.default,
    Description: CollectionDescription_1.default,
    Heading: CollectionHeading_1.default,
    Image: CollectionImage_1.default,
    Item: CollectionItem_1.default,
    Meta: CollectionMeta_1.default,
    MetaItem: CollectionMetaItem_1.default
});
exports.default = Collection;
